import {
  SeatSelectTypes,
  SeatsIOCategory,
  SortTypes,
} from "~components/reservation/constants";
import { groupCategoriesIntoZones } from "~features/seated-reservation/helpers/getChartZones";
import { log } from "~features/seated-reservation/helpers/stateLogger";
import { QueryParams } from "~features/seated-reservation/types";
import { showToast } from "~lib";

import {
  getAvailableCategoriesForChart,
  getSelectableZones,
} from "../../helpers/zoneFilters";

import { getState, setState, StoreState } from "./../index";

interface ActionProps {
  chart: StoreState["chart"];
  release: StoreState["release"];
  releasedZones: StoreState["releasedZones"];
  orgId: StoreState["orgId"];
  seatsEventKey: string;
  ticketTypes: StoreState["eventTicketTypes"];
  multiBuyPromotions: StoreState["multiBuyPromotions"];
  isAdmin: boolean;
  session: string | string[];
}

export const chartRendered = async (payload: ActionProps) => {
  log("chartRendered", payload);

  const {
    chart,
    release,
    releasedZones,
    orgId,
    seatsEventKey,
    ticketTypes,
    multiBuyPromotions,
    session,
    isAdmin,
  } = payload;

  const state = getState();

  const categories: SeatsIOCategory[] = await chart.listCategories();
  const zones = groupCategoriesIntoZones(categories);

  const selectableZones = getSelectableZones(
    releasedZones,
    zones,
    state.options,
    isAdmin
  );

  const availableCategories = getAvailableCategoriesForChart(selectableZones);

  if (!availableCategories.length) {
    showToast("Seating map has no zones available", "error");
  }

  const isFreeSelect =
    state.options.seatSelectType === SeatSelectTypes.FREE_SELECT;

  const chartConfig = {
    availableCategories: availableCategories?.length
      ? availableCategories
      : [""],
    numberOfPlacesToSelect: isFreeSelect ? null : state.options.amount,
    maxSelectedObjects: isFreeSelect ? state.options.amount : null,
  };

  void chart?.changeConfig(chartConfig);

  const continueSessionSeats =
    session === QueryParams.SessionContinue && state.seats?.length;

  setState({
    chart,
    zones, // allChartZones - move to chartStore?
    release,
    releasedZones, // convenience - might get stale??
    selectableZones,
    chartReady: true,
    sidebarIndex: continueSessionSeats ? state.sidebarIndex : 1,
    seats: continueSessionSeats ? state.seats : [],
    busyState: "idle",

    isAdmin,
    orgId,
    seatsEventKey,
    eventTicketTypes: ticketTypes,
    // availableTicketTypes: [],
    multiBuyPromotions,
    // Hack: Blues org wants lowest price first
    ...(orgId === "2648ddb4-b50c-489f-a3eb-ae0249e3db3c" && {
      options: { ...state.options, selectedSort: SortTypes.PRICE },
    }),
  });
};
